import { useEffect, useState } from "react";

type Offender = { label: string; right: number; left: number };

/** Временная отладка: ?debugOverflow=1 показывает элементы, вылезающие за ширину экрана. */
export function DebugOverflow() {
  const [enabled, setEnabled] = useState(false);
  const [items, setItems] = useState<Offender[]>([]);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    setEnabled(new URLSearchParams(window.location.search).get("debugOverflow") === "1");
  }, []);

  useEffect(() => {
    if (!enabled) return;
    const marked = new Set<HTMLElement>();
    const scan = () => {
      marked.forEach((el) => { el.style.outline = ""; });
      marked.clear();
      const vw = window.innerWidth;
      const found: Offender[] = [];
      document.body.querySelectorAll<HTMLElement>("*").forEach((el) => {
        if (el.closest("[data-debug-overflow]")) return;
        if (el instanceof SVGElement && el.ownerSVGElement) return;
        const r = el.getBoundingClientRect();
        if (r.width === 0 && r.height === 0) return;
        if (r.right > vw + 0.5 || r.left < -0.5) {
          const cls = typeof el.className === "string" ? el.className : "";
          found.push({ label: `${el.tagName.toLowerCase()}${cls ? "." + cls.trim().replace(/\s+/g, ".") : ""}`.slice(0, 80), right: Math.round(r.right), left: Math.round(r.left) });
          el.style.outline = "2px solid red";
          marked.add(el);
        }
      });
      setItems(found);
    };
    scan();
    const id = window.setInterval(scan, 1500);
    return () => { window.clearInterval(id); marked.forEach((el) => { el.style.outline = ""; }); };
  }, [enabled]);

  if (!enabled) return null;
  return (
    <div data-debug-overflow className="fixed left-2 right-2 top-2 z-[9999] max-h-[45vh] overflow-auto rounded-lg bg-black/85 p-2 font-mono text-[10px] leading-tight text-white">
      <button type="button" className="mb-1 font-bold underline" onClick={() => setCollapsed((v) => !v)}>
        Выходят за экран ({window.innerWidth}px): {items.length} {collapsed ? "▸" : "▾"}
      </button>
      {!collapsed && items.map((it, i) => (
        <div key={i} className="break-all border-t border-white/20 py-0.5">
          [{it.left}…{it.right}] {it.label}
        </div>
      ))}
    </div>
  );
}
